/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Notes_PlaceholderInputs */

const en_green_notes_placeholder = /** @type {(inputs: Green_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasting notes for green coffee...`)
};

const es_green_notes_placeholder = /** @type {(inputs: Green_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas de cata para cafe verde...`)
};

/**
* | output |
* | --- |
* | "Tasting notes for green coffee..." |
*
* @param {Green_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const green_notes_placeholder = /** @type {((inputs?: Green_Notes_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Notes_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_notes_placeholder(inputs)
	return es_green_notes_placeholder(inputs)
});